import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import Container from '../components/container';

const CTASection = ({ openContactModal }) => {
  const { t } = useTranslation('home');
  
  return (
    <Container>
      <div className="w-full py-16">
        <div className="relative bg-gradient-to-r from-primary/80 to-blue-700/80 rounded-xl overflow-hidden shadow-xl">
          {/* Background animation elements */}
          <div className="absolute inset-0 opacity-20 pointer-events-none">
            <div className="absolute top-0 left-1/4 w-40 h-40 rounded-full bg-white/20 animate-pulse-slow"></div>
            <div className="absolute bottom-0 right-1/4 w-20 h-20 rounded-full bg-white/20 animate-pulse"></div>
            <div className="absolute top-1/2 right-1/3 w-32 h-32 rounded-full bg-white/15 animate-pulse-slow delay-150"></div>
          </div>
          
          {/* Content */}
          <div className="relative z-10 px-6 py-12 md:px-12 md:py-16">
            <div className="text-center mb-8 md:mb-10">
              <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">{t('cta.title')}</h2>
              <p className="text-lg text-white/90 max-w-3xl mx-auto">{t('cta.description')}</p>
            </div>
            
            <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
              <Link
                to="/contact"
                className="bg-white text-primary hover:bg-gray-100 font-bold px-8 py-4 rounded-lg shadow-lg transition-all duration-300 transform hover:-translate-y-1 w-full sm:w-auto"
              >
                {t('ms365Alternative.cta')}
              </Link>
              
              <a
                href="https://drive.pathconnect.de/apps/appointments/pub/eMgHf4y8FMdP5g%3D%3D/form"
                className="bg-transparent border-2 border-white text-white hover:bg-white/10 font-bold px-8 py-4 rounded-lg transition-all duration-300 transform hover:-translate-y-1 w-full sm:w-auto"
                rel="noopener noreferrer"
                target="_blank"
              >
                {t('c1.bookFreeAppointment')}
              </a>
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default CTASection;